import { formatPriceToTwoDecimals } from "../../../utils";
import { useGetSbpTransferScheduleQuery } from "../queries";
import { useSbpTransferStore } from "../../../store/sbpTransferStore";

export const useSbpTransferScheduleQuery = () => {
  const amount = useSbpTransferStore(s => s.amount);
  const term = useSbpTransferStore(s => s.term);

  return useGetSbpTransferScheduleQuery({
    amount: formatPriceToTwoDecimals(amount),
    fasCode: term?.fasCode || "",
  });
};
